import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { fileText } from 'react-icons-kit/icomoon/fileText'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrDatePicker from '../components/FrDatePicker'
import UserOptions from '../components/UserOptions'
import FooterDelphus from '../components/FooterDelphus'
import Dialog from '@material-ui/core/Dialog';
import { MDBContainer, MDBIframe } from "mdbreact";
import FrMultipleSelect from '../components/FrMultipleSelect'

import api from '../services/api'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function RelatorioComissoes() {
  const [filter, setFilter] = useState({})
  const [comboVendedor, setComboVendedor] = useState([{ value: '', display: '' }])
  const [showModal, setshowModal] = useState(false)
  const [arquivo, setArquivo] = useState('')
  const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));
  const [dataVendedor, setDataVendedor] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      setComboVendedor(await api.getComboData('vendedores', null, 'pk_uex=' + auth.user))
    }
    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    if (filter.dataini && filter.datafim) {
      let filtroVendedor = ''
      if (dataVendedor.length > 0) {
        dataVendedor.forEach(item => {
          if (filtroVendedor == "") filtroVendedor = item.value;
          else filtroVendedor = filtroVendedor + "," + item.value;
        });

        filtroVendedor = '&fk_cad_canal=(' + filtroVendedor + ')'
      }
      console.log(filtroVendedor)

      setArquivo(api.backendUrl + '/api/vendedores/relatorioComissoes?dataini=' + filter.dataini + '&datafim=' + filter.datafim + '&uex=' + auth.user + filtroVendedor)

      setshowModal(true)
    } else
      swal.fire('Informe o período!', 'Informe o período', 'warning')

  }

  function escondeModal(e) {
    e.preventDefault()
    setshowModal(false)
  }


  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'vendedor':
        auxValues['vendedor'] = e.target.value;
        setDataVendedor(e.target.value)
        break

      default:
        auxValues[e.target.name] = e.target.value;
        if (typeof (e.target.value) === 'string') auxValues[e.target.name] = e.target.value.toUpperCase()
        break
    }

    setFilter(auxValues);
  };

  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h1>Relatório de Comissões</h1>
          <UserOptions />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrDatePicker
                value={(filter.dataini || '').split('T')[0]}
                onChange={handleChange}
                name="dataini"
                id="dataini"
                color="#49573B"
                label="Período"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
              />
              <FrDatePicker
                value={(filter.datafim || '').split('T')[0]}
                onChange={handleChange}
                name="datafim"
                id="datafim"
                color="#49573B"
                label=""
                variant="outlined"
                size="small"
                style={{ width: 190 }}
              />

              <FrMultipleSelect
                value={dataVendedor}
                style={{ width: 310 }}
                name="vendedor"
                id="vendedor"
                label='Vendedor'
                data={comboVendedor}
                onChange={handleChange}
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={fileText} size={18} />
                Relatório
              </button>

            </div>
          </form>
        </div>
        <br />
        <div>
          <Dialog aria-labelledby="simple-dialog-title" open={showModal} fullWidth={true} maxWidth={'lg'}>
            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">
                <MDBContainer className="text-center">
                  <MDBIframe src={arquivo} />
                </MDBContainer>
                <button onClick={escondeModal}> Sair </button>
              </div>
            </div>
          </Dialog>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default RelatorioComissoes;
